const GridSizes = {
    "2x2": {
        id: "2x2",
        gridNumRows: 2,
        gridNumCols: 2,
        gridArea: 4,
    },  
    "3x3": {
        id: "3x3",
        gridNumRows: 3,
        gridNumCols: 3,
        gridArea: 9,
    },  
    "4x4": {
        id: "4x4",
        gridNumRows: 4,
        gridNumCols: 4,
        gridArea: 16,
    },
    "3x2": {
        id: "3x2",
        gridNumRows: 2,
        gridNumCols: 3,
        gridArea: 6,
    },
    "4x3": {
        id: "4x3",
        gridNumRows: 3,
        gridNumCols: 4,
        gridArea: 12,
    },
    "4x2": {
        id: "4x2",
        gridNumRows: 2,
        gridNumCols: 4,
        gridArea: 8,
    }
}

export default GridSizes;